module.exports = __webpack_public_path__ + "static/media/IMG_0880.6828b9dc.jpg";